module.exports = __webpack_public_path__ + "img/enabled.401442b0.svg";